import { useCallback } from 'react'

interface Options {

  /** 旧授权页的返回动作，保留原有 history 与挽留处理语义。 */
  onBack: () => void

  /** 旧授权页确认协议后设置勾选并沿用原提交动作。 */
  onConfirmAgreement: () => void

  /** 旧授权页按动作 key 打开协议详情或协议列表。 */
  onOpenAgreement: (agreementKey: string) => void

  /** 旧授权页执行原有授权请求、埋点、Storage 与结果分流。 */
  onSubmit: () => void

  /** 旧授权页切换已有协议勾选 state。 */
  onToggleAgreement: () => void

  /** 旧授权页切换已有多产品选择 state。 */
  onToggleProduct: (productId: string) => void
}

export interface V2AuthorizeBusinessBridge {

  /** 用户点击返回时委托旧业务容器。 */
  onBack: () => void

  /** 用户确认皮肤本地协议弹窗后委托旧业务容器。 */
  onConfirmAgreement: () => void

  /** 用户打开协议时委托旧业务容器。 */
  onOpenAgreement: (agreementKey: string) => void

  /** 用户提交授权时委托旧业务容器。 */
  onSubmit: () => void

  /** 用户切换协议勾选时委托旧业务容器。 */
  onToggleAgreement: () => void

  /** 用户切换产品时委托旧业务容器。 */
  onToggleProduct: (productId: string) => void
}

/**
 * useV2AuthorizeBusinessBridge — 连接普通授权页既有业务与 v2 展示皮肤。
 * Hook 不拥有 API、Storage、埋点、路由或业务状态；所有副作用均由调用它的旧授权容器注入并继续执行。
 * @returns {V2AuthorizeBusinessBridge} 只供 v2 授权皮肤消费的旧业务动作接口
 */
const useV2AuthorizeBusinessBridge = ({
  onBack,
  onConfirmAgreement,
  onOpenAgreement,
  onSubmit,
  onToggleAgreement,
  onToggleProduct,
}: Options): V2AuthorizeBusinessBridge => ({
  onBack: useCallback(() => onBack(), [onBack]),
  onConfirmAgreement: useCallback(() => onConfirmAgreement(), [onConfirmAgreement]),
  onOpenAgreement: useCallback((agreementKey: string) => onOpenAgreement(agreementKey), [onOpenAgreement]),
  onSubmit: useCallback(() => onSubmit(), [onSubmit]),
  onToggleAgreement: useCallback(() => onToggleAgreement(), [onToggleAgreement]),
  onToggleProduct: useCallback((productId: string) => onToggleProduct(productId), [onToggleProduct]),
})

export default useV2AuthorizeBusinessBridge
